import { ISiteDetailsType } from '@components/SiteLeadOverview';

export * from './addNewSite';

export const addNewSiteActiveNavData = [
	{
		id: 0,
		title: 'Site Information',
		childRoute: '/site-information',
		mainRoutes: '/lms/add-new-site',
		editMainRoutes: '/lms/add-new-site',
	},
	{
		id: 1,
		title: 'Meeting Details',
		childRoute: '/meeting-details',
		mainRoutes: '/lms/add-new-site',
		editMainRoutes: '/lms/add-new-site',
	},
	{
		id: 2,
		title: 'Glue & Substrate Details',
		childRoute: '/glue-details',
		mainRoutes: '/lms/add-new-site',
		editMainRoutes: '/lms/add-new-site',
	},
];

export const addNewSiteUpcomingNavData = [
	{
		id: 0,
		title: 'Site Information',
		childRoute: '/site-information',
		mainRoutes: '/lms/add-new-site',
		editMainRoutes: '/lms/add-new-site',
	},
	{
		id: 1,
		title: 'Other Details',
		childRoute: '/other-information',
		mainRoutes: '/lms/add-new-site',
		editMainRoutes: '/lms/add-new-site',
	},
];

export type ISiteDataContextType = {
	siteData: ISiteDetailsType | undefined;
	isLoading: boolean;
	isEditing: boolean;
};
